"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _ol = require("ol");

var _proj = require("ol/proj");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _useGetPointGeomInteraction = _interopRequireDefault(require("../../../../hooks/interactions/useGetPointGeomInteraction"));

var _CoordinateWnd = _interopRequireDefault(require("../../../window/coordinate/CoordinateWnd/CoordinateWnd"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "wndStyle", "msg", "projs", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * <p>Button to retrieve the coordinate indicated by the user.</p>
 *
 * @visibleName Get Coordinate Button 
 */
var GetCoordinateButton = function GetCoordinateButton(_ref) {
  var map = _ref.map,
      wndStyle = _ref.wndStyle,
      _ref$msg = _ref.msg,
      msg = _ref$msg === void 0 ? 'Pick Coordinate' : _ref$msg,
      projs = _ref.projs,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Get Coordinate' : _ref$children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var interaction = (0, _useGetPointGeomInteraction.default)(map, msg);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visibleWnd = _useState4[0],
      setVisibleWnd = _useState4[1];

  var onClickHandler = (0, _react.useCallback)(function (event) {
    interaction.start();
  }, [interaction]);
  var onClose = (0, _react.useCallback)(function () {
    setVisibleWnd(false);
    setPosition(null);
  }, []);
  (0, _react.useEffect)(function () {
    if (interaction.geometry && !interaction.isRunning) {
      setPosition(interaction.geometry);
      setVisibleWnd(true);
      interaction.clear();
    }
  }, [interaction]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, _objectSpread(_objectSpread({}, otherProps), {}, {
      onClick: onClickHandler,
      disabled: interaction.isRunning || visibleWnd,
      children: children
    })), position && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CoordinateWnd.default //title='Get Coordinate'
    , {
      title: children,
      onClose: onClose,
      visible: visibleWnd,
      map: map,
      coordinate: position ? position.getCoordinates() : null,
      coordinateProj: map.getView().getProjection(),
      projs: projs,
      style: wndStyle
    })]
  });
};

GetCoordinateButton.propTypes = {
  /**
   * The OpenLayers ol/Map from where the coordinate will be 
   * retrieved.
   */
  map: _propTypes.default.instanceOf(_ol.Map).isRequired,

  /**
   * Array of ol/Projection to be available
   * in the window. So, the default projection once
   * the window is shown is the map projection. But
   * the user can select a different projection in the
   * window and the coordinate will be converted to
   * the selected projection.
   */
  projs: _propTypes.default.arrayOf(_propTypes.default.instanceOf(_proj.Projection)),

  /**
   * The prompt message requesting the user to indicate a 
   * position in the map.
   */
  msg: _propTypes.default.string,

  /**
  * A CSS Style to render the style for the Window
  */
  wndStyle: _propTypes.default.object,

  /**
  * The child node for the Button and Window Title:
  */
  children: _propTypes.default.node
};
var _default = GetCoordinateButton;
exports.default = _default;